export const getFormattedCtn = (ctn: string) => {
  const isFttb = ctn[0] === '0' || ctn[0] === '8';

  if (isFttb) {
    return `${ctn.replace(/^0?8(\d{1})(\d{3})(\d{2})(\d{2})$/, '08$1-$2-$3-$4')}`;
  }
  return `${ctn.replace(/^(\d{3})(\d{3})(\d{2})(\d{1,2})$/, '+7 $1 $2 $3 $4')}`;
};
